var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 1.625H14.8438V0.8125C14.8438 0.597012 14.7614 0.390349 14.6149 0.237976C14.4684 0.0856024 14.2697 0 14.0625 0C13.8553 0 13.6566 0.0856024 13.5101 0.237976C13.3636 0.390349 13.2812 0.597012 13.2812 0.8125V1.625H5.46875V0.8125C5.46875 0.597012 5.38644 0.390349 5.23993 0.237976C5.09341 0.0856024 4.8947 0 4.6875 0C4.4803 0 4.28159 0.0856024 4.13507 0.237976C3.98856 0.390349 3.90625 0.597012 3.90625 0.8125V1.625H1.5625C1.14824 1.62548 0.751084 1.79684 0.45816 2.10149C0.165235 2.40613 0.000465256 2.81917 0 3.25V19.5C0.000465256 19.9308 0.165235 20.3439 0.45816 20.6485C0.751084 20.9532 1.14824 21.1245 1.5625 21.125H17.1875C17.6018 21.1245 17.9989 20.9532 18.2918 20.6485C18.5848 20.3439 18.7495 19.9308 18.75 19.5V3.25C18.7495 2.81917 18.5848 2.40613 18.2918 2.10149C17.9989 1.79684 17.6018 1.62548 17.1875 1.625ZM3.90625 3.25V4.0625C3.90625 4.27799 3.98856 4.48465 4.13507 4.63702C4.28159 4.7894 4.4803 4.875 4.6875 4.875C4.8947 4.875 5.09341 4.7894 5.23993 4.63702C5.38644 4.48465 5.46875 4.27799 5.46875 4.0625V3.25H13.2812V4.0625C13.2812 4.27799 13.3636 4.48465 13.5101 4.63702C13.6566 4.7894 13.8553 4.875 14.0625 4.875C14.2697 4.875 14.4684 4.7894 14.6149 4.63702C14.7614 4.48465 14.8438 4.27799 14.8438 4.0625V3.25H17.1875L17.1877 6.5H1.5625V3.25H3.90625ZM17.1875 19.5H1.5625V8.125H17.1878L17.1875 19.5Z",
    fill: "url(#paint0_linear_514:309)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32662 11.875C4.7249 11.875 5.04778 11.5392 5.04778 11.125C5.04778 10.7108 4.7249 10.375 4.32662 10.375C3.92834 10.375 3.60547 10.7108 3.60547 11.125C3.60547 11.5392 3.92834 11.875 4.32662 11.875Z",
    fill: "url(#paint1_linear_514:309)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32662 17.875C4.7249 17.875 5.04778 17.5392 5.04778 17.125C5.04778 16.7108 4.7249 16.375 4.32662 16.375C3.92834 16.375 3.60547 16.7108 3.60547 17.125C3.60547 17.5392 3.92834 17.875 4.32662 17.875Z",
    fill: "url(#paint2_linear_514:309)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13522 17.875C9.5335 17.875 9.85637 17.5392 9.85637 17.125C9.85637 16.7108 9.5335 16.375 9.13522 16.375C8.73693 16.375 8.41406 16.7108 8.41406 17.125C8.41406 17.5392 8.73693 17.875 9.13522 17.875Z",
    fill: "url(#paint3_linear_514:309)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9438 11.875C14.3421 11.875 14.665 11.5392 14.665 11.125C14.665 10.7108 14.3421 10.375 13.9438 10.375C13.5455 10.375 13.2227 10.7108 13.2227 11.125C13.2227 11.5392 13.5455 11.875 13.9438 11.875Z",
    fill: "url(#paint4_linear_514:309)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32662 14.875C4.7249 14.875 5.04778 14.5392 5.04778 14.125C5.04778 13.7108 4.7249 13.375 4.32662 13.375C3.92834 13.375 3.60547 13.7108 3.60547 14.125C3.60547 14.5392 3.92834 14.875 4.32662 14.875Z",
    fill: "url(#paint5_linear_514:309)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13522 11.875C9.5335 11.875 9.85637 11.5392 9.85637 11.125C9.85637 10.7108 9.5335 10.375 9.13522 10.375C8.73693 10.375 8.41406 10.7108 8.41406 11.125C8.41406 11.5392 8.73693 11.875 9.13522 11.875Z",
    fill: "url(#paint6_linear_514:309)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13522 14.875C9.5335 14.875 9.85637 14.5392 9.85637 14.125C9.85637 13.7108 9.5335 13.375 9.13522 13.375C8.73693 13.375 8.41406 13.7108 8.41406 14.125C8.41406 14.5392 8.73693 14.875 9.13522 14.875Z",
    fill: "url(#paint7_linear_514:309)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9438 14.875C14.3421 14.875 14.665 14.5392 14.665 14.125C14.665 13.7108 14.3421 13.375 13.9438 13.375C13.5455 13.375 13.2227 13.7108 13.2227 14.125C13.2227 14.5392 13.5455 14.875 13.9438 14.875Z",
    fill: "url(#paint8_linear_514:309)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9438 17.875C14.3421 17.875 14.665 17.5392 14.665 17.125C14.665 16.7108 14.3421 16.375 13.9438 16.375C13.5455 16.375 13.2227 16.7108 13.2227 17.125C13.2227 17.5392 13.5455 17.875 13.9438 17.875Z",
    fill: "url(#paint9_linear_514:309)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_514:309",
    x1: 9.375,
    y1: 21.4094,
    x2: 9.375,
    y2: -0.277082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#00568C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354288,
    stopColor: "#0088B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806382,
    stopColor: "#3DBB95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_514:309",
    x1: 4.32662,
    y1: 11.8952,
    x2: 4.32662,
    y2: 10.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#00568C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354288,
    stopColor: "#0088B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806382,
    stopColor: "#3DBB95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_514:309",
    x1: 4.32662,
    y1: 17.8952,
    x2: 4.32662,
    y2: 16.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#00568C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354288,
    stopColor: "#0088B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806382,
    stopColor: "#3DBB95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_514:309",
    x1: 9.13522,
    y1: 17.8952,
    x2: 9.13522,
    y2: 16.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#00568C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354288,
    stopColor: "#0088B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806382,
    stopColor: "#3DBB95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_514:309",
    x1: 13.9438,
    y1: 11.8952,
    x2: 13.9438,
    y2: 10.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#00568C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354288,
    stopColor: "#0088B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806382,
    stopColor: "#3DBB95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_514:309",
    x1: 4.32662,
    y1: 14.8952,
    x2: 4.32662,
    y2: 13.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#00568C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354288,
    stopColor: "#0088B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806382,
    stopColor: "#3DBB95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_514:309",
    x1: 9.13522,
    y1: 11.8952,
    x2: 9.13522,
    y2: 10.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#00568C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354288,
    stopColor: "#0088B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806382,
    stopColor: "#3DBB95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_514:309",
    x1: 9.13522,
    y1: 14.8952,
    x2: 9.13522,
    y2: 13.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#00568C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354288,
    stopColor: "#0088B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806382,
    stopColor: "#3DBB95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_514:309",
    x1: 13.9438,
    y1: 14.8952,
    x2: 13.9438,
    y2: 13.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#00568C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354288,
    stopColor: "#0088B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806382,
    stopColor: "#3DBB95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_514:309",
    x1: 13.9438,
    y1: 17.8952,
    x2: 13.9438,
    y2: 16.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#00568C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354288,
    stopColor: "#0088B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806382,
    stopColor: "#3DBB95"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d6f88e68ebf6b4bc1ba5807adc7243be.svg";
export { ForwardRef as ReactComponent };